import { MenuItems } from '@/hooks/query';
import { useAccountInfo } from '@/hooks/query/account';
import { useEffect, useState } from 'react';
import { NavItems } from '@/types/nav';
import { useTranslations } from 'next-intl';
import { useGetSiteConfigs, useGetSiteConfigsWithSession } from '@/hooks/query/use-site-configs';
import { useFilterSabaString } from '@/hooks/query/use-saba-filter';
import { useMenuItemToNavItemMapper, SidebarSportsMenu } from '@/features/sidebar/components/sidebar-sports-menu';
import { AccountActStatus } from '@nf/utils-common/constants';

type SidebarOneSealProps = {
	virtualSports: MenuItems[]
};

export const SidebarOneSeal = ({ virtualSports }: SidebarOneSealProps) => {
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const { SiteConfigsWithSessionData } = useGetSiteConfigsWithSession();
	const { SiteConfigsData } = useGetSiteConfigs();
	const { filterSabaString } = useFilterSabaString();
	const mapMenuItemToNavItem = useMenuItemToNavItemMapper();
	const getCompleteNavItems = (): NavItems => {
		const isDeposited = user?.ActStatus === AccountActStatus.Deposited;
		const navItems: NavItems = !isDeposited ? [] : virtualSports.map(mapMenuItemToNavItem);
		if (isDeposited) {
			if (user?.EnableESportWeb) {
				navItems.push({
					productName: 'eSports',
					href: '/esportsWeb',
					className: 'side-menu__btn',
					icon: 'esports-hall',
					iconType: 'general',
					type: 'flexible',
					title: t('lbl_ESportsHall'),
					isNewWindow: true,
					hasLive: false,
					selected: false
				});
			}
			if (user?.VSTournament) {
				const virtualSport = navItems.find(x => x.sportId == '179');
				if (virtualSport?.subItems) {
					virtualSport?.subItems?.unshift({
						href: '/third-party/vs-tournament',
						className: 'side-sub-menu__btn',
						icon: 'virtual-tournament',
						iconType: 'sport',
						type: 'flexible',
						title: t('lbl_VSTournament'),
						isNewWindow: true,
						selected: false
					});
				}
			}
		}
		if (!user ? SiteConfigsWithSessionData?.EnableExchangeForBefore : user.Exchange) {
			navItems.push({
				productName: 'exchange',
				href: '/exchange',
				className: 'side-menu__btn',
				icon: SiteConfigsData?.EnableFilterSaba ? '221_special' : '221',
				iconType: 'sport',
				type: 'flexible',
				title: filterSabaString(t('lbl_Exchange')),
				isNewWindow: true,
				hasLive: false,
				selected: false
			});
		}
		return navItems;
	};
	const [navItems, setNavItems] = useState<NavItems>(getCompleteNavItems());
	useEffect(() => {
		setNavItems(getCompleteNavItems())
	}, [user?.ActStatus, user?.Exchange, user?.EnableESportWeb, user?.VSTournament, SiteConfigsWithSessionData?.EnableExchangeForBefore, virtualSports]);
	
	return <SidebarSportsMenu data={navItems} />;
};